import GlobalAxios from "../axios/axios-config";
import { IAppStoreLinks } from "../models/app-store-links";

const APP_STORE_LINKS_ROUTE =
  process.env.REACT_APP_APP + "/api/v1/SiteApp/appStroreLinks/";

export const appStoreLinksGet = () => {
  return GlobalAxios.get<IAppStoreLinks[]>(APP_STORE_LINKS_ROUTE);
};
